import FormSelect from 'src/components/form-select';

import { EEdgeType, IEdgeExtraData } from '../types';

export function CustomEdgeEditStyle({
  data,
  onChangeEdgeData,
}: {
  data: IEdgeExtraData;
  onChangeEdgeData: (data: Partial<IEdgeExtraData>) => void;
}) {
  const { edgeType = EEdgeType.BEZIER } = data || {};

  return (
    <div
      className="mt-2 flex flex-col items-center justify-center gap-4"
      data-testid="dialog-custom-edge-edit-style-panel"
    >
      <FormSelect
        label="Connection drawing style"
        data-testid="dialog-custom-edge-edit-style-select"
        className="w-full"
        options={[
          { label: 'Bezier', value: EEdgeType.BEZIER },
          { label: 'Straight', value: EEdgeType.STRAIGHT },
          { label: 'Step', value: EEdgeType.SMOOTHSTEP },
        ]}
        value={edgeType}
        onChange={(e) =>
          onChangeEdgeData({ edgeType: e.target.value as EEdgeType })
        }
      />
    </div>
  );
}
